import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import meKeys from './keyFactory';

const GetCanBulkExport = graphql(`
  query CanBulkExport {
    me {
      canBulkExport
    }
  }
`);

const useGetCanBulkExport = () => {
  const { data, ...rest } = useQuery({
    queryKey: meKeys.canBulkExport(),
    queryFn: () => {
      return gqlClient.request(GetCanBulkExport);
    },
    staleTime: Infinity,
  });

  return { canBulkExport: data?.me.canBulkExport ?? false, ...rest };
};

export default useGetCanBulkExport;
